import React from "react";
import { Close as CloseIcon } from "@mui/icons-material";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from "@mui/material";
import { usePagesTranslation } from "../locales";

const LoginConfirmDialog = ({ open, onClose, onConfirm, title, message, maxWidth = "xs" }) => {
    const { t } = usePagesTranslation();
    const dialogTitle = title ?? t("puzzle.loginConfirm.title");
    const dialogMessage = message ?? t("puzzle.loginConfirm.default-message");
    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={maxWidth}
            fullWidth
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: 2
                }
            }}
        >
            <DialogTitle sx={{
                pb: 1,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <Typography variant="h6" component="div">
                    {dialogTitle}
                </Typography>
                <Button
                    onClick={onClose}
                    sx={{ minWidth: 'auto', p: 1 }}
                >
                    <CloseIcon />
                </Button>
            </DialogTitle>

            <DialogContent sx={{ pb: 2 }}>
                <Typography variant="body1" color="text.secondary">
                    {dialogMessage}
                </Typography>
            </DialogContent>

            <DialogActions sx={{ p: 2, gap: 1 }}>
                <Button onClick={onClose} variant="outlined">
                    {t("puzzle.loginConfirm.cancel")}
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    sx={{
                        backgroundColor: '#3BA666',
                        '&:hover': { backgroundColor: '#2e7d32' }
                    }}
                >
                    {t("puzzle.loginConfirm.sign-in")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default LoginConfirmDialog;

